import { useState } from "react"

import { useTranslation } from "@/hooks/useTranslation"
import { SelectStepTitle } from "./SelectStepTitle"

import styles from "./OSStep.module.scss"

import type { OSStepProps, OSStepResult, SelectStepOption } from "."

// Selects the OS platform first (or, with options, any other value such as
// the Azure app platform) and shows the steps of the selected value
export function OSStep(props: OSStepProps): OSStepResult
export function OSStep<T extends string>(
  props: OSStepProps<T> & { options: SelectStepOption<T>[] }
): OSStepResult
export function OSStep(props: OSStepProps<string>): OSStepResult {
  const [OSPlatform, updateOSPlatform] = useState<string | null>(
    props.defaultValue ?? null
  )

  const { t } = useTranslation()

  const isWindows = OSPlatform === "windows_amd64"
  const cbProps = OSPlatform ? { OSPlatform, isWindows, t } : null

  const setOSPlatform = (platform: string) => {
    updateOSPlatform(platform)

    if (props.onOSPlatformChange) props.onOSPlatformChange(platform)
  }

  const line2 = props.waitingTitle ?? t("deployments.selectOS.2")
  const status2 = "wait" as const

  const { classes, options, placeholder, defaultValue, getSteps } = props
  const className = styles.stepSelect
  const titleProps = {
    classes,
    options,
    placeholder,
    defaultValue,
    t,
    setOSPlatform
  }

  return {
    items: [
      {
        className,
        title: <SelectStepTitle {...titleProps} />
      },
      ...(cbProps
        ? getSteps(cbProps)
        : [{ title: line2, status: status2, className: styles.step }])
    ],
    hideReadMoreLink: !OSPlatform,
    message: cbProps && props.getMessage ? props.getMessage(cbProps) : null,
    isWindows
  }
}
